/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"
import { Container, jsx } from "theme-ui"

import useSiteMetadata from "../use-site-metadata"
import NavLink from "gatsby-theme-musician/src/components/nav-link"
import AnchorLink from "react-anchor-link-smooth-scroll"

import userConfig from "../config/navigation.yml"

const homeLinkStyle = {
    variant: "layout.header.link",
    fontSize: [2, 2, 3],
}

export default ({ children, location, isBasePath }) => {
    const { title, logoImg } = useSiteMetadata()
    const userNav = userConfig.navigation

    return (
        <header
            role="banner"
            sx={{
                variant: "layout.header",
                display: ['none', null, 'block'] // Hide on mobile, show on tablet and desktop
            }}
        >
            <Container sx={{
                variant: "layout.header.container",
                display: 'flex',
                justifyContent: 'flex-end', // Align content to the right
                width: '100%'
            }}>
                <nav sx={{
                    a: {
                        variant: "layout.header.link",
                        color: 'white'
                    },
                    display: ['none', null, 'block'],
                    marginLeft: 'auto' // Push nav to the right if needed
                }}>
                    {children ? (
                        <div sx={{ variant: "layout.header.customChild" }}>{children}</div>
                    ) : null}
                    {!children && userNav.length ? (
                        <>
                            {userNav.map(nav => {
                                if (
                                    isBasePath &&
                                    (nav.url.startsWith("#") || nav.url.startsWith("/#"))
                                ) {
                                    return (
                                        <AnchorLink key={nav.text} href={nav.url} sx={{ color: 'white' }}>
                                            {nav.text}
                                        </AnchorLink>
                                    )
                                } else if (nav.url.startsWith("http")) {
                                    return (
                                        <NavLink key={nav.text} href={nav.url} sx={{ color: 'white' }}>
                                            {nav.text}
                                        </NavLink>
                                    )
                                } else {
                                    return (
                                        <NavLink key={nav.text} to={nav.url} sx={{ color: 'white' }}>
                                            {nav.text}
                                        </NavLink>
                                    )
                                }
                            })}
                        </>
                    ) : null}
                </nav>
            </Container>
        </header>
    )
}